import Offcanvas from 'bootstrap/js/dist/offcanvas.js'

const FORM_SELECTOR = '[data-document-inquiry-form]'
const CONTENT_SELECTOR = '[data-document-inquiry-content]'
const OFFCANVAS_SELECTOR = '[data-document-inquiry-offcanvas]'
const RESULT_SELECTOR = '[data-document-inquiry-result]'

async function handleSubmit(event) {
  const form = event.target.closest(FORM_SELECTOR)

  if (!(form instanceof HTMLFormElement)) {
    return
  }

  event.preventDefault()

  if (!form.reportValidity()) {
    return
  }

  const inquiry = form.closest('[data-document-inquiry]')
  const content = inquiry?.querySelector(CONTENT_SELECTOR)
  const offcanvasElement = document.querySelector(OFFCANVAS_SELECTOR)
  const result = offcanvasElement?.querySelector(RESULT_SELECTOR)
  const submit = form.querySelector('[type="submit"]')

  if (!(content instanceof HTMLElement) || !(offcanvasElement instanceof HTMLElement) || !(result instanceof HTMLElement)) {
    return
  }

  if (submit instanceof HTMLButtonElement) {
    submit.disabled = true
  }

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })

    const html = await response.text()

    /*
     * Validatiefouten blijven in het formulier staan.
     */
    if (!response.ok) {
      content.innerHTML = html

      return
    }

    /*
     * Bij succes tonen we de bevestiging in een offcanvas.
     */
    result.innerHTML = html

    dispatchInquirySubmitted(form, result)

    Offcanvas.getOrCreateInstance(offcanvasElement).show()
  } catch (error) {
    console.error('Document inquiry request failed', error)
  } finally {
    if (submit instanceof HTMLButtonElement) {
      submit.disabled = false
    }
  }
}

function dispatchInquirySubmitted(form, result) {
  const floorType = form.querySelector('[name="ps_document_contact[floorType]"]')

  const surface = form.querySelector('[name="ps_document_contact[surface]"]')

  window.dispatchEvent(
    new CustomEvent('floor.inquiry.submitted', {
      detail: {
        floorType: floorType?.value ?? '',
        surface: surface?.value ?? '',
        enhancedConversionData: result.querySelector('[data-enhanced-conversion-data]')?.dataset.enhancedConversionData,
      },
    }),
  )
}

function init() {
  document.addEventListener('submit', handleSubmit)
}

export default {
  init,
}
